import React from "react";
import Grid from "@mui/material/Grid";
import CaseDetailsItem from "../../../Common/CaseDetailsItem/CaseDetailsItem";
import SpecificCaseDetailsProps from "../../../../../types/SpecificCaseDetailsProps";

const PurchaseSpecificCaseDetails = ({ contractLawCase }: SpecificCaseDetailsProps) => {
  return (
    <Grid container>
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"buyerOrSeller"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"channel"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"contractNumber"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"itemTitle"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"articleNumber"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"purchasePrice"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"buyerPaidStatus"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"goodsOrServiceProvidedStatus"} />

      {contractLawCase.goodsOrServiceProvidedStatus !== "none" && (
        <>
          <CaseDetailsItem caseData={contractLawCase} fieldPath={"locationOfGood"} />
          <CaseDetailsItem caseData={contractLawCase} fieldPath={"hasDefects"} />
        </>
      )}

      {contractLawCase.hasDefects && (
        <>
          <CaseDetailsItem caseData={contractLawCase} fieldPath={"defectsDescriptionClient"} />
          <CaseDetailsItem caseData={contractLawCase} fieldPath={"numberRepairAttempts"} />
          <CaseDetailsItem caseData={contractLawCase} fieldPath={"numberReplacementAttempts"} />
        </>
      )}
    </Grid>
  );
};

export default PurchaseSpecificCaseDetails;
